'use client'

import ClearTripLogo from '@/src/assets/png/ClearTripLogo.png'
import FlyinLogo from '@/src/assets/svgs/FlyinLogo'
import HeyaLogo from '@/src/assets/svgs/HeyaLogo'
import { useThemeKey } from '@/src/hooks/useThemeKey'
import { VARIANT } from '@/src/utils/buildUtils'
import Image from 'next/image'

const BrandLogo = () => {
    const themeKey = useThemeKey()
    // Heya is a FLYIN build on its own host, so it is resolved before the build variant.
    if (themeKey === 'heya') {
        return <HeyaLogo sx={{ width: 49, height: 26 }} />
    }

    const variant = VARIANT
    switch (variant) {
        case 'FLYIN':
            return <FlyinLogo sx={{ width: 62, height: 26 }} />
        case 'CLEARTRIP':
            return <Image src={ClearTripLogo} alt="Cleartrip.com" width={100} height={22} />
        default:
            return <FlyinLogo sx={{ width: 62, height: 26 }} />
    }
}

export default BrandLogo
